export default __webpack_public_path__ + "static/media/avadudosa.2c9c0ea3.png";